export interface ServiceOffering {
  isOrderable: boolean;
  productId: string;
  name: string;
  consumerType: ConsumerType;
  isCampaign: boolean;
  productOfferingTitle: string;
  recurringMonthlyFee: number;
  startFee: number;
  contractTime: number;
  periodOfNotice: number;
  productIntroduction: string;
  productDescription: string;
  deliveryInformation: string;
  otherInformation: string;
  campaignText: string | undefined;
  campaignMonth: number | undefined;
  campaignRecurringMonthlyFee: number | undefined;
  speedUp: number;
  speedDown: number;
  productCategories: OfferingProductCategory[];
  standardChannels: TvChannel[];
  favoriteChannels: TvChannel[];
  numberSelectableFavoriteChannels: number;
  earliestOrderableDate: Date;
  latestOrderableDate: Date;
  serviceProviderName: string;
  serviceProviderLogoUrl: string;
  termsText: string;
  termsAndConditionsUrl: string | undefined;
  providerOpeningHours: string;
  providerEmail: string;
  providerPhone: string;
  providerWebsite: string | undefined;
  wholesaleProductCategories: WholesaleProductCategoryName[];
  isUniqueOffer: boolean | undefined;
}

export interface OfferingProductCategory {
  id: number;
  name: OfferingProductCategoryName;
}

export enum OfferingProductCategoryName {
  Internet = 'Internet',
  Tv = 'TV',
  Phone = 'Telefoni',
  Other = 'Övriga tjänster',
}

export interface TvChannel {
  id: number;
  name: string;
  description: string;
}

export enum ConsumerType {
  Private = 'PRIVATE',
  Corporate = 'CORPORATE',
}

export enum WholesaleProductCategoryName {
  Internet = 'Internet',
  Tv = 'TV',
  PreOrder = 'preOrder',
  ForcedBillingStart = 'ForcedBillingStart',
  FastIP = 'FastIP',
  VBCNoBill = 'VBC_NOBILL',
}
